var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShowRouter)?_c('Header'):_vm._e(),_c('router-view',{key:_vm.key,staticClass:"appView"}),_c('Sidebar'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }